module.exports = __webpack_public_path__ + "files/6e96b03173680dcc98b687a737c3411d.jpg";


//////////////////
// WEBPACK FOOTER
// ./images/webhook_icon.jpg
// module id = 875
// module chunks = 60